import React, { useState } from "react";
import { Users, Building2, Briefcase, ListChecks, FolderKanban, UserRound, FileSpreadsheet, ChevronRight } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useToast } from "../../hooks/use-toast";
import ImportWizard from "../../components/app/ImportWizard";

const TILES = [
  { entity: "clients",     label: "Clients",       icon: Briefcase,    blurb: "Bring in your client list before importing projects." },
  { entity: "projects",    label: "Projects",      icon: FolderKanban, blurb: "Projects with budget, rate and optional historical opening balances." },
  { entity: "team",        label: "Team members",  icon: Users,        blurb: "People with role, capacity and today's billable / cost rate." },
  { entity: "tasks",       label: "Tasks",         icon: ListChecks,   blurb: "Your reusable activity library with unit cost + billable flag." },
  { entity: "roles",       label: "Roles",         icon: UserRound,    blurb: "Job-title tags used on team member profiles." },
  { entity: "departments", label: "Departments",   icon: Building2,    blurb: "Department tags used to group team members." },
];

export default function ImportHub() {
  const { activeWorkspace } = useAuth();
  const { toast } = useToast();
  const [openFor, setOpenFor] = useState(null);

  return (
    <div>
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="text-sm text-[#6a736f]">Data import</div>
          <h1 className="font-display text-4xl mt-1">Bring your data into Full Bench</h1>
          <p className="text-sm text-[#3f4a44] mt-2 max-w-2xl">
            Migrate from another platform without retyping. Pick an entity below,
            upload a CSV, review the auto-mapped preview, and commit. We recommend
            importing in this order: <b>Clients → Projects → Team → Tasks → Roles → Departments</b>.
          </p>
        </div>
        <div className="text-xs text-[#6a736f]">
          Workspace: <span className="font-semibold text-forest">{activeWorkspace?.name}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8" data-testid="import-hub-grid">
        {TILES.map((t) => {
          const Icon = t.icon;
          return (
            <button
              key={t.entity}
              onClick={() => setOpenFor(t.entity)}
              data-testid={`import-tile-${t.entity}`}
              className="text-left bg-white border border-cream rounded-xl p-5 hover:border-forest/40 hover:shadow-md transition"
            >
              <div className="flex items-center justify-between">
                <div className="p-2 rounded-md bg-cream-2/60">
                  <Icon size={18} className="text-forest" />
                </div>
                <ChevronRight size={16} className="text-[#6a736f]" />
              </div>
              <div className="font-display text-xl mt-3">{t.label}</div>
              <div className="text-xs text-[#3f4a44] mt-1">{t.blurb}</div>
              <div className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-coral">
                <FileSpreadsheet size={12} /> Import CSV
              </div>
            </button>
          );
        })}
      </div>

      <ImportWizard
        entity={openFor}
        open={!!openFor}
        onClose={() => setOpenFor(null)}
        toast={toast}
      />
    </div>
  );
}
